import cx from 'classnames';
import { Moment } from 'moment';
// import PropTypes from 'prop-types';
import React from 'react';
import { delayEvent, getChildrenText } from "../../wui-core/src/index";
import Button from './../../wui-button/src';
import Modal from './../../wui-modal/src';
import Select from './../../wui-select/src/index';
import CalendarHeader from './CalendarHeader';
import CalendarSider from './CalendarSider';
import generate from './Generate';
import type { EventObject } from './iCalendar';
import { splitFirst } from './util/utils';
const { generateM } = generate;

const CalendarMutiRender: React.FC<any> = (props) => {
    const { clsPrefix, layout, quickSelect, fieldid, showTimeLine, onTimeEventsClick, localeStore: _locale, timeEvents, headerRender, hourCellRender, hourCellContentRender, sidebar, customInterval, isShowWeek, bodyClassName, silderModalHeader, silderModalBody,
        onSelectChange, isDragEvent, strideValue, createAdd, onYearChange, onSelect,
        stateValue, stateType, hourFillSpaceStyle, modalVisible, isFlag, rootRef, setScroll, setCreatDom, onClickUnfold, onCloseSlide, onOk, calOnChange, setStateValue, renderFCFullBody, calTypeChange,
    } = props;

    const headerChangeYear = async(value: Moment) => {
        await delayEvent(onYearChange, () => {
            setScroll(stateValue);
            onSelect && onSelect(value)
            // this.setState({ value })
            setStateValue(value)
        })
    }

    const setSelectValue = (val: Moment) => {
        // this.setState({ value: val })
        setStateValue(val)
        if (isDragEvent) {
            setCreatDom(strideValue || [])
        }
        onSelectChange && onSelectChange(val)
    }

    // 渲染全天事件
    const renderAllDayEvents = () => {
        let allDayArr: EventObject[] = [];
        let allDayArray: EventObject[] = [];
        // 获取所有全天事件存入数组allDayArr
        timeEvents?.forEach((item: any) => {
            splitFirst(generateM()(item.start).format('YYYY-MM-DD HH:mm'))[0] !== splitFirst(generateM()(item.end).format('YYYY-MM-DD HH:mm'))[0] ? allDayArr.push(item) : null
        })
        // 控制只在相关时间内显示对应全天事件
        allDayArr.forEach(item => {
            let now = generateM()(stateValue.format('YYYY-MM-DD') + ' 00:00').valueOf();
            let startDate = (new Date(generateM()(item.start).format('YYYY-MM-DD') + ' 00:00')).valueOf();
            let endDate = (new Date(generateM()(item.end).format('YYYY-MM-DD') + ' 00:00')).valueOf();
            !(Number(startDate) > Number(now)) && !(Number(endDate) < Number(now)) && allDayArray.push(item)
        })
        if (allDayArray.length !== 0) {
            let contentCx = cx({
                [`${clsPrefix}-allDay-container-right`]: true,
                [`${clsPrefix}-allDay-container-unfold`]: isFlag
            })
            return (
                <div className={`${clsPrefix}-allDay-container`} fieldid={fieldid ? `${fieldid}_allDay_container` : undefined}>
                    <div className={`${clsPrefix}-allDay-container-left`}>{_locale.langMap.allDay}</div>
                    <ul className={contentCx}>
                        {createAdd}
                        {allDayArray.map((allItem: EventObject, allIndex: number) => {
                            allItem.content = getChildrenText(allItem.content).join('')
                            // 全天事件渲染时显示的文本信息，包括时间和事件
                            let content = generateM()(allItem.start).format('YYYY-MM-DD HH:mm') + ' - ' + generateM()(allItem.end).format('YYYY-MM-DD HH:mm') + ' ' + allItem.content;
                            // 点击全天事件时打印出的参数，包括起始时间和事件名称
                            let valueTemp = { start: generateM()(allItem.start).format('YYYY-MM-DD HH:mm'), end: generateM()(allItem.end).format('YYYY-MM-DD HH:mm'), content: allItem.content }
                            return (
                                <li key={allIndex} className={`${allItem.className ? allItem.className : ''}`} fieldid={fieldid ? `${fieldid}_allDayEvents_${allIndex}` : undefined} onClick={(e) => onTimeEventsClick(e, valueTemp, generateM()(stateValue.format('YYYY-MM-DD') + ' 00:00:00'))}>{content}</li>
                            )
                        })}
                        {
                            allDayArray?.length > 3 && !isFlag ? <li className={`${clsPrefix}-allDay-container-unfold-btn`} onClick={onClickUnfold}>展开</li> : null
                        }
                    </ul>
                </div>
            );
        }
    }

    stateValue.locale(_locale.lang)
    const classPosition = cx({
        [`${clsPrefix}-root-right`]: layout !== 'left',
        [`${clsPrefix}-root-left`]: layout === 'left',
        [`${clsPrefix}-root-nosidebar`]: !sidebar,
    });
    let intervalNum = (24 / customInterval) % 1 == 0 ? customInterval : 1;
    const classTime = cx({
        [`${clsPrefix}-root-hour`]: stateType === 'hour',
        [`${clsPrefix}-root-week`]: stateType === 'week',
        [`${clsPrefix}-root-date`]: stateType === 'date',
        [`${clsPrefix}-root-hour-customInterval`]: intervalNum > 1
    });
    const classBody = cx({
        [`${clsPrefix}-schedule`]: true,
        [`${bodyClassName}`]: bodyClassName,
    })
    return (
        <div className={cx(classPosition, classTime, { [`${clsPrefix}-root`]: true, [`${clsPrefix}-quick-select`]: quickSelect })} fieldid={fieldid} ref={rootRef}>
            <CalendarHeader
                key="calendar-header"
                {...props}
                prefixCls={`${clsPrefix}-full`}
                type={stateType}
                locale={_locale.langMap}
                lang={_locale.lang}
                Select={Select}
                fieldid={fieldid}
                value={stateValue}
                headerComponents={headerRender}
                onTypeChange={calTypeChange}
                onValueChange={headerChangeYear}
                showTypeSwitch={false}
                setSelectValue={setSelectValue}
                isShowWeek={isShowWeek}
            />
            <div className={classBody}>
                {timeEvents && stateType == 'hour' ? renderAllDayEvents() : null}
                <div className={`${clsPrefix}-scrollWrap`} style={{ ...hourFillSpaceStyle }}>
                    {renderFCFullBody()}
                    {
                        ((sidebar || stateType === "hour") && stateType !== "week") && (
                            <CalendarSider key="calendar-sider"
                                prefixCls={clsPrefix}
                                lang={_locale.lang}
                                localeData={_locale.langMap}
                                value={stateValue}
                                fieldid={fieldid}
                                onMonthChange={calOnChange}
                                type={stateType == 'hour' ? 'hour' : undefined}
                                onTimeEventsClick={onTimeEventsClick}
                                showTimeLine={showTimeLine}
                                hourCellRender={hourCellRender}
                                hourCellContentRender={hourCellContentRender}
                                customInterval={customInterval}
                            />
                        )
                    }
                </div>
            </div>
            <Modal visible={modalVisible} mask onMaskClick={onCloseSlide} onCancel={onCloseSlide}>
                <Modal.Header closeButton>
                    {silderModalHeader ? silderModalHeader : _locale.langMap.modalHeader}
                </Modal.Header>
                <Modal.Body>
                    <div tinper-next-role="container">
                        {silderModalBody ? silderModalBody : _locale.langMap.modalBody}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onCloseSlide} colors="secondary" style={{ marginRight: 8 }}>{_locale.langMap.cancel}</Button>
                    <Button onClick={onOk} colors='primary'>{_locale.langMap.ok}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default CalendarMutiRender;
